import mitt from "mitt";

class PlaylistEventsManager {
  private Manager = mitt();

  constructor() {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emit(type: string, payload?: any) {
    this.Manager.emit(type, payload);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  watch(type: string, callback: (payload: any) => void) {
    this.Manager.on(type, callback);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unwatch(type: string, callback?: (payload: any) => void) {
    this.Manager.off(type, callback);
  }

  destroy() {
    this.Manager.all.clear();
  }
}

export default new PlaylistEventsManager();
